/* eslint-disable object-curly-newline,no-restricted-globals,no-alert,no-unused-vars,
import/no-named-as-default */
/* global G */
import { curry, setKey } from 'lib/util'
import {
  back,
  bulk,
  detail,
  list,
  persistChange,
  persistCheck,
  persistOption,
  persistOptions, persistScroll,
  redirect,
  submit,
} from '@app/_shared/events'
import { platform } from 'app/_shared/events/util'
import chain from 'app/_shared/events/util/chain'
import clean from 'app/_shared/events/util/clean'
import { add as addAttachment, apply, create, remove, undo } from 'app/_shared/events/attachment'
import onKey from 'app/_shared/events/util/onKey'
import search from 'app/_shared/events/search'
import searchWith from 'app/_shared/events/search/with'
import searchDevices from 'app/_shared/events/search/device'
import { acl } from 'app/_shared/events/acl'
import modelReset from 'app/_shared/events/model/reset'
import resetActionComponent from 'app/_shared/events/resetActionComponent'
import { document, item, messages, reference, user } from 'app/_shared/events/pubsub'
import listByIds from 'app/_shared/events/list/byIds'
import persistNameOption from 'app/_shared/events/persistNameOption'
import createRedirect from 'app/_shared/events/appbar/createRedirect'
import setAsRead from 'app/_shared/events/message/setAsRead'
import searchAndRecreate from 'app/_shared/events/appbar/searchAndRecreate'
import selectAndAction from 'app/_shared/events/combined/selectAndAction'
import persistChangeAndAction from 'app/_shared/events/combined/persistChangeAndAction'
import persistCheckAndAction from 'app/_shared/events/combined/persistCheckAndAction'
import redirectAndJumpTo from 'app/_shared/events/combined/redirectAndJumpTo'
import { confirm, deconfirm, jump, next, previous } from 'app/_shared/events/step'
import listCountries from 'app/_shared/events/collection/listCountries'
import listUserCountries from 'app/_shared/events/collection/listUserCountries'
import listRequestStatus from 'app/_shared/events/collection/listRequestStatus'
import listTicketStatus from 'app/_shared/events/collection/listTicketStatus'
import listMessageTypes from 'app/_shared/events/collection/listMessageTypes'
import listTicketTypes from 'app/_shared/events/collection/listTicketTypes'
import listOrganisationTypes from 'app/_shared/events/collection/listOrganisationTypes'
import link from 'app/_shared/events/link'
import loadAttachments from 'app/_shared/events/message/loadAttachments'
import menu from 'app/_shared/events/contextmenu'
import sendAndBackFromMessage from 'app/_shared/events/message/sendAndBackFromMessage'
import searchStepAndRecreate from 'app/_shared/events/searchStepAndRecreate'
import setStepTab, { CONFIRM, LIST, SEARCH, SELECT } from 'app/_shared/events/setStepTab'
import persistSerial from 'app/_shared/events/device/persistSerial'
import missingSerial from 'app/_shared/events/device/missingSerial'
import soon from 'app/_shared/events/soon'
import infinite from 'app/_shared/events/search/infinite'
import listStatusReasons from 'app/_shared/events/collection/listStatusReasons'
import modelSet from 'app/_shared/events/model/set'
import modelSave from 'app/_shared/events/model/save'
import updateUnreadMessagesCount from 'app/ticket/event/updateUnreadMessagesCount'
import updateRequestList from 'app/request/event/updateRequestList'
import session, { settings } from 'app/_shared/session'
import setCountedLabel, { setLabelOrHide } from 'app/_shared/events/tabs/setCountedLabel'
import persistTab from 'app/_shared/events/tabs/persist'
import sublist from 'app/_shared/events/util/sublist'
import toRef from 'app/_shared/events/link/toRef'
import listSoftwarePrograms from 'app/_shared/events/collection/listSoftwarePrograms'
import persistOptionAndAction from 'app/_shared/events/combined/persistOptionAndAction'
import saveAndBackFromMessage from 'app/_shared/events/message/saveAndBackFromMessage'
import { persistUnsaveChange } from 'app/_shared/events/persist/change'
import withModelKey from 'app/_shared/events/redirect/withModelKey'
import remember from 'app/_shared/events/remember'
import selectItem from 'app/request/event/selectItem'
import searchProduct from 'app/request/event/searchProduct'
import setProduct from 'app/request/event/setProduct'
import reopenRequest from 'app/request/event/reopenRequest'
import setPartner from 'app/request/event/setPartner'
import persistType from 'app/request/event/persistType'
// TODO: move to _shared:
import sendStatusMessage from 'app/ticket/event/sendStatusMessage'
import fromUserOrgs from 'app/_shared/events/search/query/fromUserOrgs'
import editMessage from 'app/_shared/events/message/editMessage'
import getMessageAttachmentsFromAttachmentsGroup
  from 'app/_shared/events/message/getMessageAttachmentsFromAttachmentsGroup'
import editAndBackFromMessage from 'app/_shared/events/message/editAndBackFromMessage'
import showAlertOrScrollToBottom from 'app/_shared/events/message/showAlertOrScrollToBottom'
import hideAlertAndScrollToBottom from 'app/_shared/events/message/hideAlertAndScrollToBottom'
import searchWithRequestCount from 'app/request/event/searchWithRequestCount'
import deleteMessage from 'app/_shared/events/message/deleteMessage'
import displayState from 'app/_shared/events/address/displayState'
import displayHouseNumber from 'app/_shared/events/address/displayHouseNumber'
import update from 'app/_shared/events/util/update'
import listStates from 'app/_shared/events/collection/listStates'
import setItem from 'app/request/event/setItem'
import { setDetailUndoKey } from 'app/ticket/action/detail'
import { toggleFavoriteFromModel } from 'app/_shared/events/favorite/toggle'
import { submitModalWith } from 'app/_shared/events/modal/submit'
import { closeModalWith } from 'app/_shared/events/modal/close'
import focusNext from 'app/_shared/events/field/focusNext'
import { showBlockingDialog } from 'app/_shared/events/dialog'
import getRequestInformation from 'app/ticket/event/getRequestInformation'
import dismissKeyboard from 'app/_shared/events/keyboard/dismiss'
import check from 'app/_shared/events/util/check'

export default {
  acl: {
    acl,
  },
  onOpen: {
    list: list('verbose'),
    listing: list('short'),
    listWithRefs: list(null),
    // needs to be async because Gallery component uses usePromise hook
    getAttachments: curry(async (module, component, event) => component[G.STATE]?.data || []),
    listWithRefsAndSetPartner: curry(async (module, component, event) => {
      const data = await list(null, module, component, event)
      return setPartner(data, module, component, event)
    }),
    listVerbose: list('verbose'),
    listByIds: listByIds('verbose'),
    listTicketTypes,
    listMessageTypes: listMessageTypes('request'),
    listCountries,
    listStates,
    listRequestStatus,
    listSoftwarePrograms,
    search: search(null),
    searchWithRequestCount: searchWithRequestCount(search, true),
    searchDevices: searchDevices(null),
    searchDevicesWithRequestCount: searchWithRequestCount(searchDevices),
    searchWithQuery: chain(
      searchWith(['query']),
      search(null),
    ),
    infinite: infinite(null),
    infiniteVerbose: infinite('verbose'),
    infiniteVerboseIfTerm: chain(
      curry((module, component, event) => {
        if (!component[G.STATE]?.[G.META]?.term) {
          throw Error('No term')
        }
      }),
      infinite('verbose'),
    ),
    infiniteWithQuery: chain(
      searchWith(['query']),
      infinite(null),
    ),
    reference,
    setAsRead,
    link,
    linkToDevice: toRef('item'),
    linkToTicket: toRef('ticket'),
    setTabSearch: searchWith(['filter']),
    getMessageAttachmentsFromAttachmentsGroup,
    infiniteWithRequestCount: searchWithRequestCount(infinite, true),
  },
  onShowAll: {
    infinite: infinite(null),
    infiniteVerbose: infinite('verbose'),
    infiniteWithRequestCount: searchWithRequestCount(infinite),
  },
  onSubmit: {
    focusNext: focusNext(null),
  },
  onSubscription: {
    reference,
  },
  onPublication: {
    refreshMessages: messages,
    updateRequestList,
    document,
  },
  onCreate: {
    createRedirect,
    getRequestInformation,
  },
  onSearch: {
    searchAndRecreate,
    searchStepAndRecreate,
  },
  onOption: {
    getConfirmationIfValue: curry(async (module, component, event) => {
      const { chosenOption, currentOption, text = null, closeOptions, openOptions } = event?.detail || event || {}

      closeOptions?.()

      const confirm = !text?.length || chosenOption.key === 'more_information' || chosenOption.key === currentOption.key
        ? true
        : await showBlockingDialog(module, component, {
          title: {
            ns: 'ticket',
            key: 'dialog.clearMessage.title',
            defaultValue: 'Delete message',
          },
          text: {
            ns: 'ticket',
            key: 'dialog.clearMessage.text',
            defaultValue: 'Are you sure you want to delelte the message?',
          },
        })

      !confirm && openOptions?.()

      return confirm
    }),
  },
  onClose: {
    redirect,
    back,
    backAndUndo: chain(
      back,
      undo,
    ),
    resetFavorite: closeModalWith('favoriteModal'),
  },
  onBack: {
    previous,
  },
  onClick: {
    detail,
    back,
    redirect,
    redirectAndJumpTo3: redirectAndJumpTo(3),
    modelRedirect: withModelKey,
    submit,
    bulk,
    create,
    remove,
    toggleFavorite: toggleFavoriteFromModel,
    favorite: submitModalWith('submitFavorite'),
    confirmStep: chain(
      confirm,
      next,
    ),
    toSelect: setStepTab(SELECT),
    toList: setStepTab(LIST),
    toConfirm: setStepTab(CONFIRM),
    toSearch: setStepTab(SEARCH),
    /**
     * Fired whenever the user clicks on the button "I still want to register the device".
     *
     * If the user has the suppressProductDevices setting, redirects them to the device confirmation
     * tab, otherwise it redirects them to the product selection tab.
     *
     * @type {Gaia.AppModule.EventHandler}
     */
    registerDevice: curry((module, component, event) => {
      const tab = settings.suppressProductDevices ? CONFIRM : LIST
      setStepTab(tab)(module, component, event)
    }),
    missingSerial,
    searchProduct: chain(
      searchProduct,
      platform({ mobile: dismissKeyboard }),
    ),
    setProduct,
    selectItemAndNext: chain(
      selectItem,
      confirm,
      next,
    ),
    setItem,
    unsetItem: chain(
      modelReset('item'),
      modelReset('itemData'),
      modelReset('equipment'),
      modelReset('product'),
      modelReset('itemInstalledAt'),
      setStepTab(SELECT),
    ),
    setLocation: chain(
      modelSet('itemInstalledAt'),
      setStepTab(CONFIRM),
      platform({ mobile: chain(
        confirm,
        next,
      ) }),
    ),
    unsetLocation: chain(
      modelReset('itemInstalledAt'),
      resetActionComponent('location'),
      setStepTab(SEARCH),
    ),
    saveLocation: chain(
      modelSave('itemInstalledAt', false),
      check,
      back,
      deconfirm,
      setStepTab(CONFIRM),
    ),
    setParty: modelSet('additionalParty'),
    unsetParty: modelReset('additionalParty'),
    jump,
    next,
    applyAndBack: chain(
      apply,
      clean,
      back,
    ),
    backAndUndo: chain(
      back,
      undo,
    ),
    sendAndBackFromMessage,
    saveAndBackFromMessage,
    editAndBackFromMessage,
    reopenRequest,
    hideAlertAndScrollToBottom,
  },
  onDelete: {
    deleteMessage,
  },
  onChange: {
    persistChange,
    persistChangeAndAction,
    persistTabAndRemember: chain(
      persistTab,
      remember,
      platform({
        mobile: update,
      }),
    ),
    persistUnsaveChange,
    persistOption,
    persistOptionAndAction,
    persistOptions,
    persistNameOption,
    persistCheck,
    persistCheckAndAction,
    selectAndAction,
    persistSerial,
    persistType,
    persistCountry: curry(async (module, component, componentInfo, attributeInfo, event) => await chain(
      persistOptions,
      displayState('state', 'country', componentInfo, attributeInfo),
      displayHouseNumber('number', 'street', componentInfo, attributeInfo),
      update,
    )(module, component, event)),
    persistStates: persistOptions,
    checkContent: curry((module, component, event) => {
      const { text } = event.detail
      setKey(text ? true : null, G.UNDO, module[G.STATE][G.ACTION][G.STATE])
    }),
    setMessage: curry((module, component, event) => {
      const { text, value } = event.detail
      setKey(text || value, 'text', module[G.STATE])
      setDetailUndoKey(module, 'message', !!text)
    }),
    addAttachment,
    editMessage,
    showAlertOrScrollToBottom,
  },
  onKeyPress: {
    searchProduct: onKey('Enter', searchProduct),
  },
  onStar: {
    soon,
  },
  onArrival: {
    showAlertOrScrollToBottom,
  },
  onAttach: {
    redirect,
    soon,
  },
  onAttachment: {
    addAttachment,
  },
  onSend: {
    sendStatusMessage,
  },
  onFocus: {
    setAsRead,
  },
  onAttachments: {
    loadAttachments,
  },
  onAction: {
    redirect,
    toSelect: setStepTab(SELECT),
    toSearch: setStepTab(SEARCH),
  },
  list: {
    sub: user,
  },
  item: {
    sub: item,
  },
  cell: {
    sub: updateUnreadMessagesCount,
  },
  onContextMenu: {
    menu: menu(null),
  },
  onPage: {
    remember,
  },
  onScroll: {
    persistScrollAndRemember: chain(
      persistScroll,
      remember,
    ),
    remember,
  },
  getOrganisationType: {
    listOrganisationTypes,
  },
  getTicketType: {
    listTicketTypes,
  },
  getRequestStatus: {
    listRequestStatus,
  },
  getStatus: {
    listRequestStatus,
  },
  getStatusReason: {
    listStatusReasons,
  },
  getTicketStatus: {
    listTicketStatus,
  },
  getSelection: {
    listTicketTypes,
    listOrganisationTypes: sublist(
      ['customer', 'independent_contractor', 'internal', 'partner'],
      listOrganisationTypes,
    ),
    listUserCountries,
  },
  getSystemMessageTypes: {
    listMessageTypes: listMessageTypes('system'),
  },
  getLabel: {
    setOwnLabel: setCountedLabel({ ns: 'ticket', key: 'myOpenRequests' }),
    setColleaguesLabel: setCountedLabel({ ns: 'ticket', key: 'otherOpenRequests' }),
    setColleaguesLabelOrHide: setLabelOrHide({ ns: 'ticket', key: 'otherOpenRequests' }),
  },
  filter: {
    userIsSubmitterAndOpen: curry((module, component, event) => ({
      submitter: session(module).user.key({ wrap: false }),
      status: { max: 79 },
    })),
    userIsSubmitterAndSolved: curry((module, component, event) => ({
      submitter: session(module).user.key({ wrap: false }),
      status: { min: 80 },
    })),
    userIsNotSubmitterAndOpen: curry((module, component, event) => ({
      submitter: `!${session(module).user.key({ wrap: false })}`,
      status: { max: 79 },
    })),
    isSolved: curry((module, component, event) => ({
      status: { min: 80 },
    })),
  },
  query: {
    userOrgsAsParentOrId: fromUserOrgs('parent', 'id'),
  },
}
